import React from 'react';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import ThemeProvider from 'threads5/themes/theme-provider';
import Threads5Theme from 'threads5/themes/Threads5';
import createTheme from 'threads5/themes/create-theme';
import getDesignTokens from 'threads5/themes/Threads5/get-design-tokens';
import Box from 'src/components-v2/Layout/Box/Box';
import { configureLayerWebviewLinks } from './iosLinks';

// base styles
import styles from './Ios.module.css';

// components
import IosTags from 'src/components/ios-tags';

// dynamically import the scripts component which invokes all of our js dependencies
const Scripts = dynamic(
  () => {
    return import('src/components/LegacyScripts');
  },
  {
    ssr: false,
  },
);

const Ios = ({ children, ...props }) => {
  const { route, query } = useRouter();
  const isDarkModeQuery = query.darkmode === 'true';
  const isLayerLinkContext = query.link_context === 'layer';

  const contentRef = React.useRef(null);

  // Layer embeds these pages in Link/SDK webviews; following a link in place
  // renders the target page inside the webview pane and breaks its layout.
  // Open every non-fragment link outside for Layer only (new tab on web,
  // device browser in the mobile SDKs), keeping table-of-contents links in
  // place and preserving the default behavior for other plaid.com consumers.
  React.useEffect(() => {
    configureLayerWebviewLinks(contentRef.current, isLayerLinkContext);
  }, [isLayerLinkContext, route]);

  const themeMode = isDarkModeQuery ? 'dark' : 'light';

  const theme = React.useMemo(() => {
    return createTheme({
      ...Threads5Theme,
      ...getDesignTokens(themeMode),
    });
  }, [themeMode]);

  return (
    <ThemeProvider theme={theme}>
      <IosTags {...props} />
      <Box
        ref={contentRef}
        className={styles.legal}
        sx={{
          'html, body, div, main, h1, h2, h3, ul, li, p, a, span, ': {
            background: `${theme.palette['background/contrast-high']}`,
            textDecorationColor: `${theme.palette['text/contrast-high']} !important`,
            color: `${theme.palette['text/contrast-high']} !important`,
            borderBottomColor: `${theme.palette['graphic/contrast-low']} !important`,
          },
          'table, tbody, tfoot, thead, tr, th, td': {
            background: `${theme.palette['background/contrast-high']}`,
            border: `${theme.palette['graphic/contrast-high']}`,
          },
        }}
      >
        {children}
      </Box>
      <Scripts route={route} />
    </ThemeProvider>
  );
};
export default Ios;
